import { useMemo } from 'react'
import { visibleAdminGroups } from '@/features/dashboard/admin/adminNavModel'
import useAuth from '@/hooks/useAuth'
import useTerminology from '@/hooks/useTerminology'
import { canAccessNavEntry } from '../nav-access'
import { ADMIN_AREAS } from './adminAreas'

/**
 * The categories of an admin area (`'admin'` or `'siteAdmin'`) this user can see in the active org — gated exactly as
 * the main sidebar gates links (feature flags, flavour, roles) — with each
 * entry's label and description resolved through the org's terminology.
 */
export default function useAdminNav(areaId = 'admin') {
    const { groups } = ADMIN_AREAS[areaId]
    const { isAuthenticated, user, activeOrg } = useAuth()
    const { t } = useTerminology()

    return useMemo(() => {
        const navAccess = {
            isAuthenticated,
            isStaff: user?.isStaff === true,
            user,
            activeOrg
        }
        return visibleAdminGroups(groups, (item) =>
            canAccessNavEntry(item, navAccess)
        ).map((group) => ({
            ...group,
            items: group.items.map((item) => ({
                ...item,
                label: item.termKey ? t(item.termKey) : item.label,
                description: item.descriptionTermKey
                    ? t(item.descriptionTermKey)
                    : item.description
            }))
        }))
    }, [groups, isAuthenticated, user, activeOrg, t])
}
